// extracted by mini-css-extract-plugin
module.exports = {"top-logo":"index_top-logo_1VHAe","topbar":"index_topbar_KdNPL"};